import GlobalVariable from '../global/global-variable'

// 添加项目
const addProjectApi = GlobalVariable.BASE_PATH + "/rest/project/add";
// 修改项目
const updateProjectApi = GlobalVariable.BASE_PATH + "/rest/project/update";
// 删除项目
const deleteProjectApi = GlobalVariable.BASE_PATH + "/rest/project/delete";
// 查询项目
const searchProjectApi = GlobalVariable.BASE_PATH + "/rest/project/search";

export default {
    // 添加项目
    addProjectApi,
    // 修改项目
    updateProjectApi,
    // 删除项目
    deleteProjectApi,
    // 查询项目
    searchProjectApi,
}



// WEBPACK FOOTER //
// ./src/request/api-org_gnss.js